import styled from 'styled-components';

export const Wrapper = styled.div``;

export const ModalTitle = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.x11};
`;

export const InputWrappers = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.x2};
  margin-bottom: ${({ theme }) => theme.spacing.x8};
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: column;
  }
`;

export const ButtonWrapper = styled.div`
  margin-inline-start: unset !important;
`;

export const Button = styled.div`
  margin: 0 ${({ theme }) => theme.spacing.x2};
  width: 120px;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    width: 50%;
    margin: 1px;
  }
`;
